module.exports = __webpack_public_path__ + "static/media/o20.06fe61fc.png";